import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName } from "../../../../util/app";
import questions from "./questions.json";

const PersonalAssessmentForm = ({ onSubmit, onCancel }) => {
    const [model, setModel] = useState({ questions: [], health_state: 0 });

    const NumberList = () => {
        const list = [];
        for (let index = 0; index < 105; index = index + 5) {
            list.push(index);
        }
        return list.reverse();
    };

    const onValueChange = (key, value) => {
        let found = false;
        const _model = { ...model };
        for (let index = 0; index < _model.questions.length; index++) {
            if (_model.questions[index].key === key) {
                found = true;
                _model.questions[index].value = value;
            }
        }
        if (!found) _model.questions.push({ key, value });
        setModel(_model);
    };

    return (
        <>
            <Helmet>
                <title>New Personal Assessment | {AppName}</title>
            </Helmet>

            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    onSubmit(model);
                }}
            >
                <div className="row">
                    <div className="col-4 bg-primary pl-2">
                        <h5>Questionnaire</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            {questions.map((item) => (
                                <React.Fragment key={item.heading}>
                                    <tr>
                                        <th>
                                            <div className="text-center">{item.heading}</div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            {item.items.map((option) => (
                                                <div key={option} className="custom-control custom-radio">
                                                    <input onChange={() => onValueChange(item.heading, option)} type="radio" name={item.heading} className="custom-control-input" id={option} />
                                                    <label className="custom-control-label" htmlFor={option}>
                                                        {option}
                                                    </label>
                                                </div>
                                            ))}
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-4 bg-primary pl-2">
                        <h5>Health State</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th colSpan="2">
                                    <strong>
                                        To help people say how hood or bad their health state is, we have drawn s scale (rather like a thermometer) on which the best state you can imagine is marked
                                        100 and worst state you can imagine id marked 0
                                    </strong>
                                </th>
                            </tr>
                            <tr>
                                <th style={{ width: "50%" }}>We would like to indicate on this scale how good or bad your own health state is today, in your opinion.*</th>
                                <td style={{ width: "50%", textAlign: "right" }}>
                                    {NumberList().map((_val) => (
                                        <div key={_val} className="custom-control custom-radio">
                                            <input
                                                onChange={({ currentTarget }) => currentTarget.checked && setModel({ ...model, health_state: _val })}
                                                type="radio"
                                                name="health_state"
                                                className="custom-control-input"
                                                id={_val}
                                            />
                                            <label className="custom-control-label" htmlFor={_val}>
                                                {_val}
                                            </label>
                                        </div>
                                    ))}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-12 text-right">
                        <button type="button" onClick={() => onCancel()} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 margin-right-10 btn-circle">
                            <i className="material-icons text-danger">close</i> Close
                        </button>
                        <button type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 btn-success btn-circle">
                            Submit Assessment <i className="material-icons">arrow_right_alt</i>
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default PersonalAssessmentForm;
